export const splitStringByAGivenCharacter = (
  str: string,
  char: string
): string[] => {
  const splitString = str.split(char).map((item) => item.trim());

  return splitString.filter((el) => el);
};
